import React, { useContext } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context';


import Items from './items';
import Card from '../../../../shared/components/UIElements/Card';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import './itemsList.css';




const ItemList = props => {
  const auth = useContext(AuthContext)

  if (props.articles.length === 0){
    return (
      <div>
        <Card>
          <h2>Мэдээ байхгүй</h2>
        </Card>
      </div>
      
    )
  }
  return (
    <div className='items'>
      {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && ( 
        <Link to='/news' style={{textDecoration: 'none'}}>
          <div className='add_news'>
            + <br/> New News
          </div>
        </Link>
      )}
      {props.articles.map(article => (
        
        <Items 
          key={article.id}
          id={article.id} 
          title={article.title}
          image={article.image}
          Url={article.url}   
        />
      ))}
    </div>
  )
}
export default ItemList;